var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AuctionIcon",
    transform: "translate(-90 -737)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(90 737)",
    fill: "#3c3c3c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352",
    transform: "translate(93.435 739.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M314.543,42.475h5.569s.693-.077.925.385a1.79,1.79,0,0,1,.231.693.453.453,0,0,1,.462.462v.535h-8.66s-.124-.766.107-1a.716.716,0,0,1,.462-.231s-.274-.771.9-.848",
    transform: "translate(-313.037 -32.427)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M327.553,6.226,330.9,7.953l-2.051,3.995L325.5,10.22Z",
    transform: "translate(-322.175 -5.117)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M333.048,2.67l3.563,1.835s.324.108.432-.108a1.066,1.066,0,0,0-.216-1.08,10.778,10.778,0,0,0-2.051-1.3,2.529,2.529,0,0,0-1.3-.216C333.048,1.914,332.509,2.346,333.048,2.67Z",
    transform: "translate(-327.67 -1.777)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M326.607,24.475l-3.563-1.835s-.324-.108-.432.108a1.066,1.066,0,0,0,.216,1.08,10.777,10.777,0,0,0,2.051,1.3,2.529,2.529,0,0,0,1.3.216C326.607,25.231,327.147,24.8,326.607,24.475Z",
    transform: "translate(-319.957 -17.418)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 7,
    height: 1.339,
    transform: "translate(7.442 3.97) rotate(25)",
    fill: "#efefef"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuction);
export default __webpack_public_path__ + "static/media/auction.51674b9a.svg";
export { ForwardRef as ReactComponent };